"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryStorageAdapter = void 0;
/**
 * Wraps a `Storage` object so that key-values are read first from the wrapped storage, falling back to the in-memory cache when the storage returns
 * null. Writes update both the wrapped storage and the cache.
 *
 * This is intended for use with `localStorage` and `sessionStorage` to work around a race condition in iOS where writing then reading in quick
 * succession occasionally returns null instead of the expected value.
 */
var InMemoryStorageAdapter = /** @class */ (function () {
    function InMemoryStorageAdapter(storage) {
        this.storage = storage;
        this.cache = new Map();
    }
    Object.defineProperty(InMemoryStorageAdapter.prototype, "length", {
        get: function () {
            return this.storage.length;
        },
        enumerable: false,
        configurable: true
    });
    InMemoryStorageAdapter.prototype.clear = function () {
        this.cache.clear();
        this.storage.clear();
    };
    /**
     * Try to load a value from the wrapped storage. If the value exists update the in-memory cache. If it doesn't return the cached value.
     */
    InMemoryStorageAdapter.prototype.getItem = function (key) {
        var value = this.storage.getItem(key);
        if (typeof value !== "undefined" && value !== null) {
            this.cache.set(key, value);
            return value;
        }
        if (this.cache.has(key)) {
            return this.cache.get(key);
        }
        return value;
    };
    InMemoryStorageAdapter.prototype.key = function (index) {
        return this.storage.key(index);
    };
    InMemoryStorageAdapter.prototype.removeItem = function (key) {
        this.cache.delete(key);
        this.storage.removeItem(key);
    };
    InMemoryStorageAdapter.prototype.setItem = function (key, value) {
        this.cache.set(key, value);
        this.storage.setItem(key, value);
    };
    return InMemoryStorageAdapter;
}());
exports.InMemoryStorageAdapter = InMemoryStorageAdapter;
